import { interfaces } from 'inversify/lib/interfaces/interfaces';
import { useContext, useState } from 'react';

import { DIContext } from '../context/di';
import { getDependencies } from '../utils';

export function useInject<T>(serviceIdentifier: interfaces.Newable<T>): T {
  const { mainContainer } = useContext(DIContext);

  const [injectionResult] = useState(() => getDependencies(
    serviceIdentifier,
    mainContainer!.get.bind(mainContainer),
    mainContainer!.isBound.bind(mainContainer)
  ));

  return injectionResult;
}
